import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditCustomerOnboardingContactDataEndpoint extends Endpoint {

    adaptValues({
                    taxpayerIdentificationNumber,
                    contactData
                }) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            collections_contact_name: contactData.collectionsContactName,
            collections_contact_email: contactData.collectionsContactEmail,
            collections_contact_area_number: contactData.collectionsContactAreaNumber,
            collections_contact_phone_number: contactData.collectionsContactPhoneNumber,
            orders_contact_name: contactData.ordersContactName,
            orders_contact_email: contactData.ordersContactEmail,
            orders_contact_area_number: contactData.ordersContactAreaNumber,
            orders_contact_phone_number: contactData.ordersContactPhoneNumber,
        }
    }
}